import { createContext, useContext } from 'react';
import type { PublicUser } from './types';

export const authQueryKey = ['auth', 'me'] as const;

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthContextValue {
  user: PublicUser | null;
  status: AuthStatus;
  isAuthenticated: boolean;
  setUser: (user: PublicUser) => void;
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
}
